var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',{staticClass:"text-center py-16"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"48"}}),_c('p',{staticClass:"mt-4 text-caption",domProps:{"innerHTML":_vm._s(_vm.$t('page.pay.pay-progress-text'))}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }